import styled from 'styled-components';
import {device} from './responsives.js';

const font_themes = {
  fontfam: "Roboto", //not taking combined font
  headerfontwght: "600",
  fontclr: "#84828F",
  parfontsz: "1.25em",
  parfontwght: "600",
  reviewfontsz: "1.2em",
  headerfontsz: "1.4em"
}

export const RevHeader = styled.p`
  margin: 0px 8px 8px 0px;
  display: inline-block;
  font-weight: ${props => font_themes.headerfontwght};
  font-size: ${props => font_themes.headerfontsz};
  padding-left: 10px;
`

export const RevNodeContainer = styled.div`
  display: inline-block;
  height: auto;
  margin: 0px;
  padding: 0px;
`

export const RevNode1 = styled.button`
  display: inline-block;
  height: 40px;
  width: auto;
  border-radius: 20px;
  border: #ffffff;
  background-color: ${props => props.attrColor || "palevioletred"};
  color: #ffffff;
  padding: 8px 12px;
  text-align: center;
  font-weight: bold;
  font-size: ${props => font_themes.parfontsz};
`

export const RevNode2 = styled(RevNode1)`
  margin-left: 38px;
  background-color: ${props => props.attrColor || "palevioletred"};
`

export const RevList = styled.div`
  padding: 10px 0px;
`
// hold reviews inside of ReviewsContainer component
export const RevsContainer = styled.div`
  padding: 20px 8px 8px;
  margin-bottom: 20px;
`

//styling for ReviewItem in review_item.js
export const Reviews = styled.div`
  padding: 10px;
  font-family: ${props => font_themes.fontfam};
  font-size: ${props => font_themes.reviewfontsz};
`
export const ReadMore = styled.button`
  background-color: transparent;
  color: #6ec1e4;
  height: auto;
  border: none;
  font-size: 14px;
  font-family: ${props => font_themes.fontfam};
  &:hover {
    color: #6ea3e4
  }
`
//^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^

export const Arrow = styled.img`
  display: inline-block;
  position: absolute;
  bottom: 10;
  height: 40px;
  margin-left: 0px;
  margin-bottom: 0px;
  text-align: bottom;
`

export const ViewMore = styled.button`
  background: transparent;
  display: block;
  margin-bottom: 20px;
  float: right;
  height: 30px;
  border: none;
  font-size: 20px;
  @media ${device.tablet}{
    float: left;
  }
`
